const isHomePage = document
    .querySelector("body")
    .classList.contains("template-index");

const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

(function initReducedMotion() {
    if (prefersReducedMotion) {
        // Disable autoplay for all videos and pause videos already playing
        const videos = document.querySelectorAll('video[autoplay]');
        videos.forEach(video => {
            if (!video.paused) video.pause();
            video.removeAttribute('autoplay');
        })
    }
})();

// Announcement Bar
(function initAnnouncementBar() {
    const list = document.querySelector('.announcement-bar-slides');
    if (!list) return;

    if (prefersReducedMotion) {
        list.classList.add('_has-reduced-motion');
        return;
    }

    // Sanftes Überblenden statt horizontalem Schieben (Stile in as-ck-custom-styles.css)
    const slides = list.querySelectorAll('.announcement-bar-slide:not(.is-clone)');
    const total = slides.length;
    list.classList.add('is-fading');
    slides[0]?.classList.add('is-active');
    if (total < 2) return;

    let index = 0;

    setInterval(() => {
        slides[index].classList.remove('is-active');
        index = (index + 1) % total;
        slides[index].classList.add('is-active');
    }, 4000);
})();

// Quick Shop
(function InitQuickShop() {
    document.querySelectorAll('.quick-shop-qty').forEach((quickShop) => {
        quickShop.querySelectorAll('button').forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                window.addToCart(quickShop.getAttribute('data-variantid'), button.innerText);
            })
        });
    });
})();



// Cart Drawer
(function InitCartDrawer() {
  const cartDrawer = document.querySelector("#cart-drawer");
  const cartDrawerContents = cartDrawer.querySelector(".cart-drawer-contents");

  const cartOverlay = cartDrawer.parentElement;
  const cartToggles = document.querySelectorAll(
    '[aria-controls="cart-overlay"]'
  );

  const replaceAmountPlaceholder = (el, remainingCents) => {
    if (!el || !el.innerHTML.includes("[amount]")) return;

    const amount = Math.max(0, Math.abs(remainingCents)) / 100;
    const formatted = amount.toFixed(2).replace(".", ",");

    el.innerHTML = el.innerHTML.replace(
      "[amount]",
      `<strong>${formatted}</strong>`
    );
  };

  //Dir fehlen nur noch [amount] € zum Geschenk!
  //Limitierte Geschenkbox
  const refreshCartProgress = (amount = 0, debugString) => {
    amount = Number(amount) || 0;
    const amounts = window.cartProgressAmounts || [];
    amounts.sort((a, b) => a - b);

    const steps = amounts.length;
    if (!steps) return;

    const wrapperEl = document.getElementById("cart-progress");
    const fillbarEl = document.getElementById("cart-progress-fill");

    if (!wrapperEl || !fillbarEl) return;

    const stepWidth = 100 / steps;
    let progressPercent = 0;

    // Spread Logic
    if (amount < amounts[0]) {
      progressPercent = (amount / amounts[0]) * stepWidth;
    } else {
      let accumulated = 0;

      for (let i = 0; i < steps; i++) {
        const prev = i === 0 ? 0 : amounts[i - 1];
        const curr = amounts[i];

        if (amount >= curr) {
          accumulated += stepWidth;
        } else {
          const stepProgress = (amount - prev) / (curr - prev);
          accumulated += stepProgress * stepWidth;
          break;
        }
      }

      progressPercent = Math.min(accumulated, 100);
    }

    fillbarEl.style.width = `${progressPercent}%`;

    // Re-Layout the Dots
    amounts.forEach((_, index) => {
      const dotEl = document.getElementById(`cart-progress-dot-${index + 1}`);
      const labelEl = document.getElementById(
        `cart-progress-label-${index + 1}`
      );

      const left = stepWidth * (index + 1);

      if (dotEl) dotEl.style.left = `${left}%`;
      if (labelEl) {
        labelEl.style.left = `${left}%`;
        labelEl.classList.add("shown")

        if (index === steps - 1) {
          labelEl.style.transform = "translateX(-100%)";
          labelEl.style.textAlign = "right";
        }
      }
    });

    // Messages
    document.querySelectorAll(".cart-drawer-progress-text").forEach((el) => {
      el.classList.remove("shown")
    });

    if (amount < amounts[0]) {
      const el = document.getElementById("cart-progress-message-1");
      if (el) {
        replaceAmountPlaceholder(el, amounts[0] - amount);
        el.classList.add("shown")
      }
      return;
    }

    if (amount >= amounts[steps - 1]) {
      const el = document.getElementById("cart-progress-message-finished");
      if (el) el.classList.add("shown")
      return;
    }

    // middle messages
    for (let i = 1; i < steps; i++) {
      if (amount < amounts[i]) {
        let el = document.getElementById(`cart-progress-message-${i + 1}`);
        replaceAmountPlaceholder(el, amounts[i] - amount);
        if (el) el.classList.add("shown")
        return;
      }
    }
  };

  const onCartChange = (cart, pos = "") => {
    const totalPrice = cart.total_price || 0;
    window.cartTotalPrice = totalPrice;
    refreshCartProgress(totalPrice, pos);
  };

  const initRemoveProductButton = (element) => {
    element.addEventListener("click", async () => {
      let cartReq = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: element.getAttribute("data-key"),
          quantity: 0,
        }),
      });
      await renderItems("POS3");

      document.dispatchEvent(
        new CustomEvent("cart:change", {
          detail: { cart: await cartReq.json() },
        })
      );
    });
  };

  const initQuantitySelector = (selector) => {
    const display = selector.querySelector(".cart-drawer-amount");

    selector
      .querySelectorAll(".cart-drawer-minus, .cart-drawer-plus")
      .forEach((button) => {
        const handleChangeQuantity = () => {
          let value = parseInt(display.innerText.trim());

          if (button.classList.contains("cart-drawer-minus")) {
            value = value < 1 ? 0 : value - 1;
          } else {
            value = value + 1;
          }

          display.innerText = value;

          fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: selector.getAttribute("data-key"),
              quantity: value,
            }),
          })
            .then((res) => res.json())
            .then(async (cart) => {
              await renderItems();
              // Dispatch cart change event
              document.dispatchEvent(
                new CustomEvent("cart:change", {
                  detail: { cart: cart },
                })
              );
              // Dispatch item updated event
              document.dispatchEvent(
                new CustomEvent("cart:item-updated", {
                  detail: {
                    cart: cart,
                    item: cart.items.find(
                      (item) => item.key === selector.getAttribute("data-key")
                    ),
                  },
                })
              );
            })
            .catch((err) => {
              alert("Error updating cart");
              console.log(error);
            });
        };

        button.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            handleChangeQuantity();
          }
        });
        button.addEventListener("click", () => {
          handleChangeQuantity();
        });
      });
  };

  const renderItems = async (pos) => {
    let cartContainer = document.querySelector("#cart-overlay");

    if (!cartContainer) {
      return console.error("No Container Found");
    }

    let cartContentResponse = await fetch(
      `${window.Shopify.routes.root}?section_id=mini-cart`
    );

    if (!cartContentResponse.ok) {
      return console.error("Cart is not Loading via AJAX");
    }

    let cartContent = await cartContentResponse.text();
    let tempDiv = document.createElement("div");
    let footerElement = cartContainer.querySelector("footer");

    tempDiv.innerHTML = cartContent;

    cartContainer.querySelector(".cart-drawer-contents").innerHTML =
      tempDiv.querySelector(".cart-drawer-contents").innerHTML;

    if (cartContainer.querySelector("#cart-progress-message-1")) {
      cartContainer.querySelector("#cart-progress-message-1").innerHTML =
        tempDiv.querySelector("#cart-progress-message-1").innerHTML;
    }

    if (cartContainer.querySelector("#cart-progress-message-2")) {
      cartContainer.querySelector("#cart-progress-message-2").innerHTML =
        tempDiv.querySelector("#cart-progress-message-2").innerHTML;
    }

    if (cartContainer.querySelectorAll(".cart-drawer-progress-line-label")) {
      let originalLabels = cartContainer.querySelectorAll(
        ".cart-drawer-progress-line-label"
      );
      let newlabels = tempDiv.querySelectorAll(
        ".cart-drawer-progress-line-label"
      );
      newlabels.forEach((label, index) => {
        originalLabels[index].setAttribute(
          "data-reached",
          label.hasAttribute("data-reached")
        );
      });
    }

    footerElement.innerHTML = tempDiv.querySelector("footer").innerHTML;

    cartContainer
      .querySelectorAll(".cart-drawer-selector")
      .forEach((selector) => {
        initQuantitySelector(selector);
      });

    cartContainer
      .querySelectorAll(".cart-drawer-remove")
      .forEach((selector) => {
        initRemoveProductButton(selector);
      });

    let dataDiv = tempDiv.querySelector("[data-cart-json-element]");

    if (dataDiv) {
      let cartJSON = JSON.parse(dataDiv.innerText);

      /*Refresh Cart Module Outsitde of cart*/
      /*Todo: Define Variables on top for Performance*/
      document.querySelector(
        ".cart-trigger sup"
      ).innerText = `(${cartJSON.item_count})`;
      cartDrawer.querySelector(
        "header sup"
      ).innerText = `(${cartJSON.item_count})`;

      if (!footerElement) {
        return;
      }

      if (cartJSON.item_count > 0) {
        cartContainer.querySelector("footer").style.display = "block";
      } else {
        cartContainer.querySelector("footer").style.display = "none";
      }

      onCartChange(cartJSON, "AFTERCARTJSON");
    }

    return;

    // Leaving Legacy Code here until im sure i got everything ported

    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        const lineItems = [];
        const lineItem = `
				<article>
                    <img src="[CART_ITEM_IMAGE]" alt="" />
					<div class="cart-drawer-details">
						<div class="cart-drawer-main">
							<a href="[CART_ITEM_URL]" class="cart-drawer-title">
								[CART_ITEM_TITLE]
                                <div class="cart-item-subtitle"></div>
							</a>
							<div class="cart-drawer-combo"><!--metafields--></div>
						</div>
						<div class="cart-drawer-money">
							<div>[CART_ITEM_PRICE] €</div>
							<span class="cart-drawer-selector" data-key="[CART_ITEM_KEY]">
								<span class="cart-drawer-minus" role="button" tabindex="0"></span>
								<span class="cart-drawer-amount">[CART_ITEM_QTY]</span>
								<span class="cart-drawer-plus" role="button" tabindex="0"></span>
							</span>
						</div>
					</div>
				</article>`;

        data.items.forEach((item) => {
          // data is added to the cartMetafieldsData object in the theme.liquid file
          const itemMetafields =
            window.cartMetafieldsData && window.cartMetafieldsData[item.id]
              ? window.cartMetafieldsData[item.id]
              : {};
          let itemStuckpreis = null;
          let itemGrundpreis = null;
          let metafields = "";
          if (itemMetafields.product_stuckpreis) {
            itemStuckpreis = itemMetafields.product_stuckpreis;
          }
          if (itemMetafields.produkt_grundpreis) {
            itemGrundpreis = itemMetafields.produkt_grundpreis;
          }

          if (itemStuckpreis) {
            metafields = `
							${itemStuckpreis}
							<br/>
						`;
          }
          if (itemGrundpreis) {
            metafields += `
							${itemGrundpreis}
							<br/>
						`;
          }
          lineItems.push(
            lineItem
              .replace("[CART_ITEM_KEY]", item.key)
              .replace(
                "[CART_ITEM_PRICE]",
                (item.final_line_price / 100).toLocaleString("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              )
              .replace("[CART_ITEM_IMAGE]", item.image)
              .replace("[CART_ITEM_TITLE]", item.product_title)
              .replace("[CART_ITEM_QTY]", item.quantity)
              .replace("<!--metafields-->", metafields)
              .replaceAll("[CART_ITEM_URL]", item.url)
          );
        });

        if (lineItems.length) {
          cartDrawer.querySelector(".cart-drawer-value").innerText = `${(
            data.total_price / 100
          ).toLocaleString("de-DE", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })} €`;
          cartDrawerContents.innerHTML = lineItems.join("");
          cartDrawerContents
            .querySelectorAll(".cart-drawer-selector")
            .forEach((selector) => {
              initQuantitySelector(selector);
            });
          cartOverlay.querySelector("footer").removeAttribute("style");
        } else {
          cartDrawerContents.innerHTML =
            '<div class="cart-drawer-empty">Dein Warenkorb ist im Moment leer.</div>';
          cartOverlay.querySelector("footer").style.display = "none";
        }
      })
      .catch((error) => {
        alert("Error fetching cart");
        console.log(error);
      });
  };

  const openCart = async () => {
    // Dispatch before open event
    document.dispatchEvent(new CustomEvent("on:cart-drawer:before-open"));

    cartOverlay.querySelector("footer").style.display = "none";
    cartDrawerContents.innerHTML = "";

    cartOverlay.classList.add("is-active");
    cartOverlay.hidden = false;

    // Set focus within cart overlay
    cartOverlay.querySelector('[aria-controls="cart-overlay"]').focus();

    // Trap focus
    const focusableElements = cartOverlay.querySelectorAll(
      'a, button, [role="button"], input'
    );
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement =
      focusableElements[focusableElements.length - 1];

    firstFocusableElement.addEventListener("keydown", (e) => {
      if (e.code === "Tab" && e.shiftKey) {
        e.preventDefault();
        lastFocusableElement.focus();
      }
    });

    lastFocusableElement.addEventListener("keydown", async (e) => {
      if (e.code === "Tab" && !e.shiftKey) {
        e.preventDefault();
        firstFocusableElement.focus();
      }
    });

    await renderItems("POSITION1");

    // Dispatch after open event
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent("on:cart-drawer:after-open"));
    }, 100);
  };

  const closeCart = () => {
    // Dispatch before close event
    document.dispatchEvent(new CustomEvent("on:cart-drawer:before-close"));

    cartOverlay.hidden = true;
    cartOverlay.classList.remove("is-active");

    // Re-set focus to cart trigger
    document.querySelector(".cart-trigger").focus();

    // Dispatch after close event
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent("on:cart-drawer:after-close"));
    }, 100);
  };

  const toggleCart = () => {
    if (cartOverlay.hidden) {
      openCart();
    } else {
      closeCart();
    }
  };

  window.addToCart = (variantId, quantity = 1) => {
    openCart();

    // Get the selected quantity from the hidden input
    const selectedQuantity = document.getElementById("selected-quantity")
      ? parseInt(document.getElementById("selected-quantity").value)
      : quantity;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: selectedQuantity,
      }),
    })
      .then((res) => res.json())
      .then(async (item) => {
        await renderItems();
        // Dispatch cart change event

        //THIS IS ALSO WRONG; STOP RE WRITIING THE CART WITH PRODUCT DATA?! TODO: FIX OR LEAVE OUT
        // document.dispatchEvent(
        //   new CustomEvent("cart:change", {
        //     detail: { cart: item },
        //   })
        // );
        // Dispatch item added event
        document.dispatchEvent(
          new CustomEvent("cart:item-added", {
            detail: { item: item },
          })
        );
      })
      .catch((error) => {
        alert("Error adding to cart");
        console.log(error);
      });
  };

  cartToggles.forEach((toggle) => {
    toggle.addEventListener("click", toggleCart);
  });

  cartDrawer.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeCart();
    }
  });

  // Klick auf den abgedunkelten Bereich neben dem Drawer schließt den Warenkorb
  cartOverlay.addEventListener("click", (e) => {
    if (e.target === cartOverlay) {
      closeCart();
    }
  });

  // Shopify Cart Events
  document.addEventListener("cart:change", function (event) {
    onCartChange(event.detail.cart);
  });

  document.addEventListener("cart:item-added", function (event) {
    // event also triggered cart:change
    // console.log('cart:item-added', event.detail);
    //WHY??? THIS IT TOTALLY WRONG AND SHOULD NOT REPLACE THE CART! TODO: FIX THIS 
    //onCartChange({ total_price: event.detail.item.final_line_price });
  });

  document.addEventListener("cart:item-removed", function (event) {
    // onCartChange(event.detail.cart);
  });

  document.addEventListener("cart:item-updated", function (event) {

    // onCartChange(event.detail.cart);
  });

  // Cart drawer events
  document.addEventListener("on:cart-drawer:before-open", function (event) {
    // console.log('Cart drawer opening...');
  });

  document.addEventListener("on:cart-drawer:after-open", function (event) {
    // console.log('Cart drawer opened', event);
  });

  document.addEventListener("on:cart-drawer:before-close", function (event) {
    // console.log('Cart drawer closing...');
  });

  document.addEventListener("on:cart-drawer:after-close", function (event) {
    // console.log('Cart drawer closed');
  });

  document.addEventListener("DOMContentLoaded", function (event) {
    refreshCartProgress(window.cartTotalPrice, "DEBUG DOMCONTENTLOADED");
  });
})();

// Mobile Menu
(function InitMobileMenu() {
    document
        .querySelector(".mobile-menu-trigger")
        .addEventListener("click", (event) => {
            document.querySelector(".mobile-menu").classList.toggle("is-active");
            document
                .querySelector(".mobile-menu-trigger")
                .classList.toggle("is-active");
        });
})();

// Header
(function InitHeader() {
    const header = document.getElementById("header");
    let lastScrollTop = 0;

    window.addEventListener("scroll", () => {
        let currentScroll = window.scrollY || document.documentElement.scrollTop;

        if (currentScroll > lastScrollTop) {
            header.classList.add("is-down-scroll");
            header.classList.remove("is-up-scroll");
        } else if (currentScroll < lastScrollTop) {
            header.classList.add("is-up-scroll");
            header.classList.remove("is-down-scroll");
        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;

        const banneHeight = document.querySelector(".page-banner")
            ? document.querySelector(".page-banner").offsetHeight
            : window.innerHeight;

        if (isHomePage) {
            if (window.scrollY >= banneHeight - 149) {
                header.classList.add("is-shrinked");
            } else {
                header.classList.remove("is-shrinked");
            }
        }

        // if (window.scrollY >= banneHeight - 117) {
        if (window.scrollY >= banneHeight / 2) {
            header.classList.add("is-hidden");
        } else {
            header.classList.remove("is-hidden");
        }

        if (window.scrollY >= banneHeight) {
            header.classList.add("is-filled");
        } else {
            header.classList.remove("is-filled");
        }
    });
})();

// Hero Banner
(function InitHeroBanner() {
    const heroBanner = document.querySelector(".hero-banner.is-carousel");

    if (heroBanner) {
        const prevButton = heroBanner.querySelector(".hero-banner-prev");
        const nextButton = heroBanner.querySelector(".hero-banner-next");

        // Select both video and img elements to handle all media types
        const mediaDesktop = heroBanner.querySelectorAll(".mobile-hidden video, .mobile-hidden img");
        const mediaMobile = heroBanner.querySelectorAll(".mobile-only video, .mobile-only img");
        const overlays = heroBanner.querySelectorAll(".hero-banner-overlay");
        const textBoxes = heroBanner.querySelectorAll(".hero-banner-holder");
        const slides = heroBanner.querySelector(".hero-banner-status");

        slides.classList.add("is-animation-1-ready");

        setTimeout(() => {
            slides.classList.add("is-animating-1-now");
        }, 150);

        const slideAction = (activeIndex, nextActiveIndex) => {
            // Ensure nextActiveIndex is valid
            if (nextActiveIndex < 0 || nextActiveIndex >= mediaDesktop.length) {
                return;
            }

            // Remove active state from previous slide if it exists
            if (activeIndex !== -1 && activeIndex < mediaDesktop.length) {
                mediaDesktop[activeIndex].classList.remove("is-active");
                mediaMobile[activeIndex].classList.remove("is-active");
                if (overlays[activeIndex]) overlays[activeIndex].classList.remove("is-active");
                textBoxes[activeIndex].classList.remove("is-active");

                textBoxes[activeIndex]
                    .querySelector(".hero-banner-text")
                    .classList.remove("is-animated");
                textBoxes[activeIndex]
                    .querySelector(".hero-banner-text")
                    .classList.remove("is-active-second");
            }

            // Add active state to next slide
            mediaDesktop[nextActiveIndex].classList.add("is-active");
            mediaMobile[nextActiveIndex].classList.add("is-active");
            if (overlays[nextActiveIndex]) overlays[nextActiveIndex].classList.add("is-active");
            textBoxes[nextActiveIndex].classList.add("is-active");
                textBoxes[nextActiveIndex]
                    .querySelector(".hero-banner-text")
                    .classList.add("is-animated");

                slides.className = "hero-banner-status";

                setTimeout(() => {
                    slides.className = `hero-banner-status is-animation-${
                        nextActiveIndex + 1
                    }-ready is-active-${nextActiveIndex + 1}`;
                    textBoxes[nextActiveIndex]
                        .querySelector(".hero-banner-text")
                        .classList.add("is-active");
                }, 200);

                setTimeout(() => {
                    slides.classList.add(`is-animating-${nextActiveIndex + 1}-now`);
                    textBoxes[nextActiveIndex]
                        .querySelector(".hero-banner-text")
                        .classList.add("is-active");
                }, 400);

                setTimeout(() => {
                    textBoxes[nextActiveIndex]
                        .querySelector(".hero-banner-text")
                        .classList.add("is-active-second");
                }, 600);
        };

        prevButton.addEventListener("click", () => {
            clearInterval(window.heroBannerIntervalId);
            let activeIndex = Array.from(mediaDesktop).findIndex((media) =>
                media.classList.contains("is-active")
            );
            // If no active element found, default to 0
            if (activeIndex === -1) {
                activeIndex = 0;
            }
            const nextActiveIndex =
                activeIndex === 0 ? mediaDesktop.length - 1 : activeIndex - 1;
            slideAction(activeIndex, nextActiveIndex);
        });

        nextButton.addEventListener("click", () => {
            clearInterval(window.heroBannerIntervalId);
            let activeIndex = Array.from(mediaDesktop).findIndex((media) =>
                media.classList.contains("is-active")
            );
            // If no active element found, default to 0
            if (activeIndex === -1) {
                activeIndex = 0;
            }
            const nextActiveIndex =
                activeIndex === mediaDesktop.length - 1 ? 0 : activeIndex + 1;
            slideAction(activeIndex, nextActiveIndex);
        });

        setTimeout(() => {
            slides.classList.add("is-active-1");

            // Do not skip to next slide
            if (prefersReducedMotion) {
                return;
            }

            window.heroBannerIntervalId = setInterval(() => {
                let activeIndex = Array.from(mediaDesktop).findIndex((media) =>
                    media.classList.contains("is-active")
                );
                // If no active element found, default to 0
                if (activeIndex === -1) {
                    activeIndex = 0;
                }
                const nextActiveIndex =
                    activeIndex === mediaDesktop.length - 1 ? 0 : activeIndex + 1;
                slideAction(activeIndex, nextActiveIndex);
            }, 6000);
        });
    }
})();

// Featured Products
(function InitFeaturedProducts() {
    const element = document.querySelector(".featured-topic-subtitle ul");

    if (element) {
        const items = element.querySelectorAll("li");
        let currentIndex = 0;

        setInterval(() => {
            items[currentIndex].classList.remove("is-active");
            currentIndex = (currentIndex + 1) % items.length;
            items[currentIndex].classList.add("is-active");
        }, 3000);
    }
})();

// Best Choice
(function InitBestChoice() {
    const section = document.querySelector(".best-choice");

    if (section) {
        const lis = section.querySelectorAll("li");
        const targets = section.querySelectorAll(".best-choice-product");

        lis.forEach((li, index) => {
            li.addEventListener("click", () => {
                lis.forEach((li2) => {
                    li2.classList.remove("is-active");
                });

                targets.forEach((target) => {
                    target.classList.remove("is-active");
                    target.classList.remove("in-animation");
                });

                li.classList.add("is-active");
                targets[index].classList.add("is-active");

                setTimeout(() => {
                    targets[index].classList.add("is-animated");

                    setTimeout(() => {
                        targets[index].classList.add("in-animation");

                        setTimeout(() => {
                            targets[index].classList.remove("is-animated");
                        }, 500);
                    }, 150);
                }, 150);
            });
        });
    }
})();

// Big Quote
(function InitBigQuote() {
    const element = document.querySelector(".big-quote-text");

    if (element) {
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];

                if (entry.isIntersecting) {
                    element.classList.add("is-active");
                } else {
                    element.classList.remove("is-active");
                }
            },
            {
                threshold: 0.5,
            }
        );

        observer.observe(element);
    }
})();

// PDP Buy Bar
(function InitBuyBar() {
    const bar = document.querySelector(".pdp-buy");

    if (bar) {
        window.addEventListener("scroll", function () {
            if (window.scrollY > 0) {
                bar.classList.add("is-scrolled");
            } else {
                bar.classList.remove("is-scrolled");
            }
        });
    }
})();

// PDP Tabs
(function InitPdpTabs() {
    const tabs = document.querySelector(".pdp-tabs");

    if (tabs) {
        tabs.querySelectorAll(".pdp-tab-title").forEach((tab) => {
            tab.addEventListener("click", () => {
                tab.parentElement.classList.toggle("is-active");
            });
        });
    }
})();

// PDP Quantity Selector
(function InitPdpQuantitySelector() {
    const selector = document.querySelector(".pdp-buy-qty");

    if (selector) {
        const dropdown = selector.querySelector(".qty-selector");
        const selection = selector.querySelector(".qty-selection");
        
        const openSelector = () => {
            dropdown.classList.add("is-active");
            selection.classList.add("is-active");
            selection.setAttribute('aria-expanded', 'true');
        }

        const closeSelector = () => {
            dropdown.classList.remove("is-active");
            selection.classList.remove("is-active");
            selection.setAttribute('aria-expanded', 'false');
        }

        const setSelectorOption = (option) => {
            const isVariantSelector = option.getAttribute('data-variant-selector') === 'true';
            document.querySelector(".final-price").innerText = option.getAttribute("data-price");
            selection.querySelector(".qty-selection-text").innerHTML = option.querySelector(".qty-selector-text").innerHTML;

            if (isVariantSelector) {
                const variantId = option.getAttribute('data-value');
                
                // Update the image
                // document.querySelector(".pdp-banner-image").src = option.getAttribute('data-variant-image');
                // update the hidden variant input
                // document.getElementById("selected-variant").value = variantId;
                // update the variant query parameter with the id in data-value
                
                const url = new URL(window.location.href);
                url.searchParams.set('variant', variantId);
                window.location.href = url.toString();
            } else {
                // Update the hidden quantity input
                document.getElementById("selected-quantity").value = option.getAttribute("data-value");
            }
            // Update aria-activedescendant
            dropdown.setAttribute('aria-activedescendant', option.id);
        }

        selection.addEventListener("click", () => {
            const open = selection.getAttribute('aria-expanded') === 'true';
            dropdown.classList.toggle("is-active");
            selection.classList.toggle("is-active");
            selection.setAttribute('aria-expanded', `${!open}`);
        });


        dropdown.addEventListener('focusout', (e) => {

            // do nothing if relatedTarget is contained within listboxEl
            if (dropdown.contains(e.relatedTarget)) {
                return;
            }

            closeSelector();
        });

        selector.addEventListener('keydown', (e) => {
            const openKeys = ['ArrowDown', 'ArrowUp', 'Enter', ' '];
            const open = selection.getAttribute('aria-expanded') === 'true';

            if (!open && openKeys.includes(e.key)) {
                openSelector();
            } else if (open && e.key === 'Enter') {
                setSelectorOption(e.target);
                closeSelector();
            } else if (open && e.key === 'Escape') {
                closeSelector();
            }

        });

        dropdown.querySelectorAll("li").forEach((element) => {
            element.addEventListener("click", () => {
                setSelectorOption(element)
                closeSelector();
            });
        });
    }
})();

// PDP Bundle Overlay
(function InitPdpBundleOverlay() {

    // Check for dialogs in the current document
    const dialogs = document.querySelectorAll(".drawer");

    dialogs.forEach(dialog => {

        // Find all elements that control the dialog
        const dialogToggle = document.querySelectorAll("[aria-controls='" + dialog.id + "']");

        const toggleDialog = (e) => {
            e.preventDefault();

            if (dialog.open) {
                dialog.close();
            } else {
                dialog.showModal();
            }
        }

        // Toggle dialog via button click
        dialogToggle.forEach(el => {
            el.addEventListener("click", toggleDialog);
        });

        // Close dialog on backdrop click
        dialog.addEventListener('click', (e) => {
            const contentParent = e.target.closest('.drawer__inner');

            if (e.target && !contentParent && e.target.tagName !== 'BUTTON') {
                dialog.close();
            }
        });
    });

})();

// FAQ
(function IniFaq() {
    const faqs = document.querySelector(".faq-section");

    if (faqs) {
        faqs.querySelectorAll("li.is-faq").forEach((element) => {
            element.addEventListener("click", () => {
                element.classList.toggle("is-active");
            });
        });
    }
})();

// Age consent
(function InitAgeConsent() {
    if (
        window.location.hostname.includes("admin.shopify.com") ||
        window.location.hostname.includes("localhost") ||
        window.location.hostname.includes("online-store-web.shopifyapps.com")
    )
        return;

    //Ignore Designmode
    if(window.Shopify.designMode){
      return;
    }

    // check if cookie consent is set
    const cookieConsent = document.cookie
        .split("; ")
        .find((row) => row.startsWith("age_consent="));

    // Only show age consent if not in Shopify admin domain or else the cookie consent is already set
    if (!cookieConsent) {
        const ageConsentDialog = document.querySelector(".age-consent");
        const ageConsentConfirmButton = ageConsentDialog.querySelector(".age-consent-button[data-action='yes']");
        ageConsentDialog.classList.add('is-active');
        ageConsentConfirmButton.focus();

        ageConsentConfirmButton.addEventListener("click", () => {
                // Set cookie to live for 364 days, secure only
                const expires = new Date();
                expires.setTime(expires.getTime() + 364 * 24 * 60 * 60 * 1000);
                document.cookie =
                    "age_consent=true; expires=" +
                    expires.toUTCString() +
                    "; path=/; Secure";
                ageConsentDialog.classList.remove('is-active');
            });

        document
            .querySelector(".age-consent-button[data-action='no']")
            .addEventListener("click", () => {
                // redirect to https://jokolade.de/
                window.location.href = "https://jokolade.de/";
            });
    }
})();
